export const loanError = (error: unknown): { message: string; reason?: string } => {
  const response = (
    error as { response?: { status?: number; data?: { code?: string; message?: unknown; reason?: string } } }
  )?.response;
  const data = response?.data;
  if (
    response?.status === 422 &&
    data?.code === "INVALID_LOAN_HISTORY" &&
    typeof data.message === "string" &&
    data.message.trim()
  ) {
    return { message: data.message, reason: data.reason };
  }
  return { message: "保存できませんでした。入力内容を確認して再試行してください。" };
};
